<template>
  <v-container class="fill-height fondo-login" fluid>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64" @click="overlay = false"></v-progress-circular>
          </v-overlay>
        </div>
      </v-col>
      <div class="login-header">
        Proveedores Locales Unidad Minera Tía María
      </div>
      <v-col cols="12" xs="9" sm="12" md="9" lg="9" xl="9">
      </v-col>
      <v-col cols="12" xs="3" sm="12" md="3" lg="3" xl="3">
        <v-card ref="form1">
          <v-card-text>
            <!-- <p style="font-size:20px" class="text-center">Empresas</p> -->
            <v-text-field
              v-model="usuario"
              autofocus
              color="accent"
              label="Usuario"
              prepend-icon="mdi-account-circle"
              :rules="[() => !!usuario || 'Campo requerido']"
              :error-messages="errorMessages"
              ref="usuario"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              type="password"
              color="accent"
              label="Contraseña"
              prepend-icon="mdi-lock"
              required
              :rules="[() => !!password || 'Campo requerido']"
              :error-messages="errorMessages"
              ref="password"
              @keypress.enter="ingresar"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn @click="ingresar" color="#0076A8" block class="mb-5" dark><span>Ingresar</span></v-btn>
          </v-card-actions>
          <v-card-text class="grey-card-t">
            <p class="text-plomo">
              Si tiene dudas, por favor contacte a la mesa de ayuda de su localidad y un
              encargado de Proveeduría le apoyará.
            </p>
            <p class="text-plomo">
              Cocachacra: +51 968 907 742<br />
              Email: DC-TiaMaria@SouthernPeru.com.pe
            </p>
          </v-card-text> 
        </v-card>
        <v-row class="mt-10">
          <v-col cols="4"></v-col>
          <v-col cols="4 d-flex justify-center">
          </v-col>
          <v-col cols="4"></v-col>
        </v-row>
      </v-col>
      <div class="login-footer">
        <span class="footer-left">#MineríaQueCreceContigo</span>
        <!-- <span class="footer-right">Southern Perú</span> -->
      </div>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="color" :timeout="timeout">
        <v-icon dark class="pr-5">{{icon}}</v-icon>
        {{error}}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      value: "",
      mask: "##:##",
      usuario: null,
      password: null,
      error: null,
      overlay: false,
      errorMessages: "",
      formHasErrors: false,
      snackbar: false,
      color: "#2A3B4D",
      icon: "mdi-thumb-up",
      timeout:2000
    };
  },
  computed: {
    form1() {
      return {
        usuario: this.usuario,
        password: this.password
      };
    }
  },
  watch: {
    // whenever question changes, this function will run
    question: function(newQuestion, oldQuestion) {
      this.answer = "Waiting for you to stop typing...";
      console.log("entro al watch");
    }
  },
  created() {
    const usuario = localStorage.getItem("usuario")
    if (usuario) {
      const u = JSON.parse(usuario)
      const rol = u.rol

      if (rol === 'ADMINISTRADOR') {
        this.$router.replace({ name: 'empresa' })
      } else if (rol === 'PROVEEDOR') {
        this.$router.replace({ name: 'oportunidades' })
      } else if (rol === 'CONTRATISTA') {
        this.$router.replace({ name: 'requerimiento' })
      }
    }
    let me = this;
    // Add a request interceptor
    axios.interceptors.request.use(
      function(config) {
        // Do something before request is sent
        me.overlay = true;
        return config;
      },
      function(error) {
        // Do something with request error
        me.overlay = false;
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      function(response) {
        // Any status code that lie within the range of 2xx cause me function to trigger
        // Do something with response data
        me.overlay = false;
        return response;
      },
      function(error) {
        // Any status codes that falls outside the range of 2xx cause me function to trigger
        // Do something with response error
        return Promise.reject(error);
      }
    );
  },
  methods: {
    validar() {
      /*Validacion Forms */
      this.error = null;
      this.formHasErrors = false;
      Object.keys(this.form1).forEach(f => {
        if (!this.form1[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
    },
    ingresar() {
      this.validar();
      if (this.formHasErrors == false) {
        const res = axios
          .post("api/Usuarios/Login", {
            usuario: this.usuario,
            contraseña: this.password
          })
          .then(response => {
            this.snackbar=false;
            const usuario = response.data
            // console.log(usuario)
            this.$store.dispatch("guardarUsuario", usuario);
            localStorage.setItem("usuario", JSON.stringify(usuario))
            var obj = response.data;
            var res = [];
            for (var i in obj) {
              res.push(obj[i]);
            }
            // console.log(res);
            //Guardamos el id de empresa y rol
            localStorage.setItem("idusuario", res[0]);
            localStorage.setItem("rol", res[6]);
            localStorage.setItem("empresa", res[7]);
            localStorage.setItem("empresacontratista", res[8]);
            const rol = res[6]; 
            // console.log(rol);
            if (rol === 'ADMINISTRADOR') {
              this.$router.replace({ name: 'empresa' }).catch(() => {})
            } else if (rol === 'PROVEEDOR') {
              this.$router.replace({ name: 'panelproveedor' }).catch(() => {})
            } else if (rol === 'CONTRATISTA') {
              this.$router.replace({ name: 'panelcontratista' }).catch(() => {})
            } else {
              this.$router.replace({ name: 'login' }).catch(() => {})
            }
          })
          .catch(err => {
            this.overlay = false;
            if (err.response.status == 400) {
              this.error = "No existe el usuario o sus datos son incorrectos";
              //this.error = err.response.data;
            } else if (err.response.status == 404) {
              this.error = "No existe el usuario o sus datos son incorrectos";
              //this.error = err.response.data;
            } else {
              this.error = "Ocurrió un error";
            }
            this.snackbar = true;
            this.color = "#E53935";
            this.icon = "mdi-alert";
          });
      }
    }
  }
};
</script>
<style>
/* ===============================
   FONDO GENERAL
================================ */
.container {
  padding: 0px;
}
.theme--light.v-application {
  background-color: #B2B4B2 !important;
}

.fondo-login {
  position: relative;
  min-height: 100vh;
  background-image: url('https://cesemstorage.blob.core.windows.net/logos-contratistas/fondo2.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* Overlay suave para contraste */
.fondo-login::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 0;
}

/* ===============================
   HEADER
================================ */
.login-header {
  position: absolute;
  top: 28px;
  left: 0;
  width: 100%;
  text-align: center;
  color: #ffffff;
  font-size: 3.2rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-shadow: 0 3px 10px rgba(0, 0, 0, 0.6);
  z-index: 2;
}

/* ===============================
   CARD LOGIN
================================ */
.v-card {
  border-radius: 14px !important;
  background: rgba(255, 255, 255, 0.96) !important;
}

.v-card__text {
  padding: 24px 24px 10px 24px !important;
}

.v-card__actions {
  padding: 0 24px 20px 24px !important;
}

.v-btn {
  font-weight: 600 !important;
}

/* ===============================
   TEXTOS DE AYUDA
================================ */
.text-plomo {
  font-size: 0.75rem;
  font-weight: 600;
  color: #2f2f2f;
  text-align: justify;
  line-height: 1.4;
}

.grey-card-t {
  background: #c4c7c6;
  padding: 14px 20px;
  border-radius: 0 0 14px 14px;
}

/* ===============================
   FOOTER
================================ */
.login-footer {
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-weight: 600;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.65);
  z-index: 2;
}

.footer-left {
  font-size: 1.35rem;
  font-weight: 600;
}

.footer-right {
  font-size: 1.35rem;
}

/* ===============================
   OVERLAY / LOADING
================================ */
.v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.55) !important;
}

/* ===============================
   TOOLBAR & DRAWER (GLOBAL)
================================ */
.v-toolbar__content,
.v-toolbar__extension {
  background-color: #2D8C9E !important;
}

.theme--dark.v-navigation-drawer {
  background-color: #545859 !important;
}

/* ===============================
   RESPONSIVE
================================ */
@media (max-width: 960px) {
  .login-header {
    font-size: 1.6rem;
    padding: 0 16px;
  }

  .login-footer {
    padding: 0 16px;
  }
}

@media (max-width: 600px) {
  .login-header {
    top: 16px;
    font-size: 1.3rem;
  }

  .login-footer {
    flex-direction: column;
    gap: 6px;
    bottom: 12px;
  }
}
*
{
  font-family: 'Gotham', Arial, sans-serif !important;
  font-weight: 300;
}
</style>